import React, { useLayoutEffect, useRef } from 'react';
import { FormLayoutComposer, IFormLayoutProps } from 'components/common/form/renderer/FormLayoutComposer';
import { FormComponentValueSelectable } from 'components/common/form/layout/control';
import { useSelector } from 'react-redux';
import { formSliceState } from 'store/formSlice';
interface IFilter {
    name: string;
    value: string;
}
export default function AggregationMetricForm(props: IFormLayoutProps) {
    const lastFilterRefs = useRef<IFilter[]>([]);
    const handleFiltersChange = (filters: IFilter[]) => {
        if (JSON.stringify(filters) == JSON.stringify(lastFilterRefs.current)) {
            return;
        }
        if (lastFilterRefs.current.length == 0) {
            lastFilterRefs.current = structuredClone(filters);
            return;
        }
        lastFilterRefs.current = structuredClone(filters);
        const componentRegister = props.hookForm.form.getElementValuesRegister('mi_list');
        if (componentRegister?.componentStatePropsRef.current) {
            const selected: FormComponentValueSelectable[] =
                componentRegister?.componentStatePropsRef.current?.selectedOption;
            const selectedLabels = selected.map((s) => s.label);
            const allValues: FormComponentValueSelectable[] =
                componentRegister?.componentStatePropsRef.current?.allValues;
            const ag = lastFilterRefs.current.find((f) => f.name == 'agg_function')?.value;
            const af = lastFilterRefs.current.find((f) => f.name == 'agg_is_fiscal')?.value;
            const valuesToSelect = allValues.filter(
                (v) => selectedLabels.includes(v.label) && v.props.agg_function == ag && v.props.agg_is_fiscal == af,
            );
            props.hookForm.form.hookFormSetValue(
                'mi_list',
                valuesToSelect.map((v) => v.value),
            );
        }
    };

    const emptySharedState = useRef({});
    const sharedState: any = useSelector((state: any) => {
        const formData = (state?.form as formSliceState).formElementsSharedState[props.hookForm.form.formKey];
        if (formData && typeof formData['mi_list'] != 'undefined') {
            if (Object.keys(formData['mi_list']).length === 0) {
                return emptySharedState.current;
            }
            return formData['mi_list'];
        }
        return emptySharedState.current;
    });

    useLayoutEffect(() => {
        if (sharedState?.filtersStatus?.filters?.length) {
            handleFiltersChange(sharedState.filtersStatus.filters);
        }
    }, [sharedState]);

    return <FormLayoutComposer props={props} />;
}
